import React, {useEffect, useRef, useState} from 'react';
import DynaModal from "../Modal/DynaModal";
import _axios from "../../httpService";
import {toast} from "react-toastify";
import {prefixUrl} from "../../utils/utilsData";
import DynaInput from "../A13/DynaView/DynaInput";
import DynaSelectBox from "../A13/DynaView/DynaSelectBox";
import DynaTimePicker from "../A13/DynaView/DynaTimePicker";
import DynaDatePicker from "../A13/DynaView/DynaDatePicker";
import DynaTextarea from "../A13/DynaView/DynaTextarea";
import NumericFunction from "../../utils/NumericFunction";

const ModalFollowUp = ({onClose, listName, pkValue, setShowModal, setReRender}) => {

  const fileRef = useRef(null);
  let today = new Date();
  let time = today.getHours() + ":" + today.getMinutes();
  const options = {
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    calendar: "persian",
  };
  const todayDate = new Date().toLocaleDateString("fa-IR", options);
  const [userList, setUserList] = useState([])
  const [sendData, setSendData] = useState({
    alarmText: "",
    alarmTime: time,
    priority: "متوسط",
    referencedUser: "",
    alarmDate: NumericFunction.p2e(todayDate),
    alarmType: "time",
    pkValue: pkValue,
    listName: listName,
    description: ""
  })
  const [file, setFile] = useState();
  const [fileUploadName, setFileUploadName] = useState("فایل خود را وارد کنید")

  useEffect(() => {
    _axios.get(prefixUrl() + "/followUp/?request=usersList").then((response) => {
      if (response.data.status) {
        setUserList(response.data.usersList);
      } else {
        toast.error(response.data.message);
      }
    });
  }, []);

  const modalDataHandle = () => {

    if (sendData.alarmText === "") {
      return toast.error("عنوان را وارد کنید")
    }

    if (sendData.referencedUser === "") {
      return toast.error("ارجاع به را وارد کنید")
    }

    if (sendData?.alarmType === "date" && sendData.alarmDate === "") {
      return toast.error("تاریخ را وارد کنید")
    }

    if (sendData?.alarmType === "time" && sendData.alarmDate === "") {
      return toast.error("زمان را وارد کنید")
    }

    if (sendData.description === "") {
      return toast.error("توضیحات را وارد کنید")
    }

    const myFormData = new FormData()
    for (const singleData in sendData) {
      myFormData.append(singleData, sendData[singleData])
    }
    myFormData.append('file', file)

    _axios.post(prefixUrl() + "/followUp/?request=followUpSubmit", myFormData).then((response) => {
      if (response.data.status) {
        toast.success(response.data.message)
        setShowModal(false)
        setReRender(Math.random())
      } else {
        toast.error(response.data.message)
      }
    })
  }

  const handleFileInputChange = (event) => {
    const file = event.target.files[0];
    setFileUploadName(file?.name)
    setFile(event.target.files[0])
  }

  return (
    <DynaModal onClose={onClose} className={'simple-modal-saden'}>

      <div className="header-modal">
        <p>پیگیری پرونده</p>

        <div onClick={onClose}>
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M9.16936 15.5801C8.97936 15.5801 8.78938 15.5101 8.63938 15.3601C8.34938 15.0701 8.34938 14.5901 8.63938 14.3001L14.2994 8.64011C14.5894 8.35011 15.0694 8.35011 15.3594 8.64011C15.6494 8.93011 15.6494 9.41011 15.3594 9.70011L9.69936 15.3601C9.55936 15.5101 9.35936 15.5801 9.16936 15.5801Z"
              fill="white"/>
            <path
              d="M14.8294 15.5801C14.6394 15.5801 14.4494 15.5101 14.2994 15.3601L8.63938 9.70011C8.34938 9.41011 8.34938 8.93011 8.63938 8.64011C8.92937 8.35011 9.40936 8.35011 9.69936 8.64011L15.3594 14.3001C15.6494 14.5901 15.6494 15.0701 15.3594 15.3601C15.2094 15.5101 15.0194 15.5801 14.8294 15.5801Z"
              fill="white"/>
            <path
              d="M15 22.75H9C3.57 22.75 1.25 20.43 1.25 15V9C1.25 3.57 3.57 1.25 9 1.25H15C20.43 1.25 22.75 3.57 22.75 9V15C22.75 20.43 20.43 22.75 15 22.75ZM9 2.75C4.39 2.75 2.75 4.39 2.75 9V15C2.75 19.61 4.39 21.25 9 21.25H15C19.61 21.25 21.25 19.61 21.25 15V9C21.25 4.39 19.61 2.75 15 2.75H9Z"
              fill="white"/>
          </svg>
        </div>
      </div>

      <div className="form-content-modal">

        <div style={{gridColumn: "1/-1"}}>
          <DynaInput label={"عنوان"}
                     name={"alarmText"}
                     className={"solid-dyna-input"}
                     placeholder={"عنوان را وارد کنید"}
                     value={sendData?.alarmText}
                     type={"text"}
                     setDataFromComponent={(data) => {
                       setSendData({...sendData, ...data})
                     }}
          />
        </div>

        <DynaSelectBox options={userList}
                       hasFilter={true}
                       label={"ارجاع به"}
                       className={"solid-dyna-input"}
                       value={sendData?.referencedUser}
                       onChange={(data) => setSendData({...sendData, referencedUser: data?.value})}
        />

        <DynaSelectBox
          options={[
            {label: "فوری", value: "فوری"},
            {label: "زیاد", value: "زیاد"},
            {label: "متوسط", value: "متوسط"},
            {label: "کم", value: "کم"}
          ]}
          hasFilter={false}
          label={"اولویت"}
          className={"solid-dyna-input"}
          value={sendData?.priority}
          onChange={(data) => setSendData({...sendData, priority: data?.value})}
        />

        <DynaSelectBox
          options={[
            {label: "تاریخ", value: "date"},
            {label: "ساعت", value: "time"},
          ]}
          hasFilter={false}
          label={"نوع هشدار"}
          className={"solid-dyna-input"}
          value={sendData?.alarmType}
          onChange={(data) => setSendData({...sendData, alarmType: data?.value})}
        />

        {sendData.alarmType === "time" ?
          <DynaTimePicker
            name={"alarmTime"}
            label="زمان"
            className={"solid-dyna-input"}
            value={sendData?.alarmTime}
            setDataFromComponent={(data) => {
              setSendData({...sendData, ...data})
            }}/> :
          sendData.alarmType === "date" ?
            <DynaDatePicker label={"تاریخ"}
                            name={"alarmDate"}
                            className={"solid-dyna-input"}
                            value={sendData?.alarmDate}
                            setDataFromComponent={(data) => {
                              setSendData({...sendData, ...data})
                            }}
            /> : <></>}

        <div style={{gridColumn: "1/-1"}}>
          <DynaTextarea label={"توضیحات"}
                        name={"description"}
                        style={{height: '140px'}}
                        className={"solid-dyna-input"}
                        placeholder={"توضیحات را وارد کنید"}
                        value={sendData?.description}
                        type={"text"}
                        setDataFromComponent={(data) => {
                          setSendData({...sendData, ...data})
                        }}
          />
        </div>

        <button onClick={() => fileRef.current.click()} className={"upload-file-but"}>
          {fileUploadName}
        </button>
        <input style={{display: "none"}} type={"file"} onChange={handleFileInputChange} ref={fileRef}/>

        <div className="button-modal">
          <button onClick={onClose} className="cancel-saden-modal">انصراف</button>
          <button className="accept-saden-modal" onClick={modalDataHandle}>ثبت</button>
        </div>

      </div>
    </DynaModal>
  );
};

export default ModalFollowUp;